import SNG_ICON_MAPPING_JSON from './sng-icon-mapping.json';

/**
 * Constant: What happens to an SNG icon: replaced by a Material glyph, redrawn by design, or kept
 */
export const SNG_ICON_DECISIONS = ['material', 'redraw', 'keep'] as const;

export type SngIconDecision = typeof SNG_ICON_DECISIONS[number];

/**
 * Interface: One SNG icon class and what replaces it; `color` names the `icon--color--*` modifier a colour-baked
 * class turns into
 */
export interface SngIconMapping {
  sng: string;
  decision: SngIconDecision;
  material?: string;
  color?: string;
  migrated?: boolean;
  note?: string;
}

/**
 * Constant: Prefix of the colour modifier classes shared by SNG and Material icons
 */
export const ICON_COLOR_CLASS_PREFIX: string = 'icon--color--';

/**
 * Constant: Prefix of the size modifier classes shared by SNG and Material icons
 */
export const ICON_SIZE_CLASS_PREFIX: string = 'icon--size--';

/**
 * Constant: Every SNG icon class the app uses, classified in `sng-icon-mapping.json`
 */
export const SNG_ICON_MAPPING: SngIconMapping[] = SNG_ICON_MAPPING_JSON as SngIconMapping[];

/**
 * Constant: The mapping keyed by SNG icon class
 */
export const SNG_ICON_BY_CLASS: ReadonlyMap<string, SngIconMapping> = new Map(
  SNG_ICON_MAPPING.map(entry => [entry.sng, entry]),
);
